const bible = require('./voiceJobs.json');
const sermon = require('./sermonVoiceJob.json');
module.exports = [
  ...bible.map(job => ({ ...job, kind: 'bible', title: `エゼキエル書 ${job.label} 朗読募集`, path: `/jobs/ezekiel/${job.slug}`, imageKey: `ezekiel-${job.slug}`, sourcePath: `/bible/ezekiel/${job.chapter}/1?type=norm` })),
  { ...sermon, kind: 'sermon', title: `説教「${sermon.label}」朗読募集`, path: `/jobs/sermon/${sermon.slug}`, imageKey: sermon.slug, sourcePath: `/sermon/${sermon.slug}` },
];
